import { getApp } from "firebase/app";
import {
  CustomProvider,
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";

let defaultAppCheck = null;

/**
 * App Check for the default Firebase app (legacy httpsCallable routes).
 * Required when Cloud Functions enforce App Check — without this, localhost
 * calls fail with a browser "CORS" error and FirebaseError: internal.
 */
export function initializeDefaultAppCheck() {
  // Unit tests must never initialize live token refresh or reCAPTCHA.
  if (process.env.NODE_ENV === "test") return null;
  if (defaultAppCheck || typeof window === "undefined") return defaultAppCheck;
  // Unit-test DOMs do not have a browser App Check token store and must not
  // start the production auto-refresh loop merely because NODE_ENV is not
  // production. Callable clients are mocked at their own boundary in tests.
  if (process.env.NODE_ENV === "test") return null;

  const isDevelopment = process.env.NODE_ENV !== "production";
  const siteKey = String(
    process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY || "",
  ).trim();
  const debugToken = isDevelopment ? String(
    process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN || "",
  ).trim() : "";
  const debugEnabled = isDevelopment;

  if (!siteKey && !debugEnabled) return null;

  if (debugEnabled) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN =
      debugToken && debugToken !== "true" ? debugToken : true;
  }

  const provider = siteKey
    ? new ReCaptchaV3Provider(siteKey)
    : new CustomProvider({
        getToken: async () => {
          throw new Error("App Check debug mode is not active.");
        },
      });

  defaultAppCheck = initializeAppCheck(getApp(), {
    provider,
    isTokenAutoRefreshEnabled: true,
  });
  return defaultAppCheck;
}
